module.exports = __webpack_public_path__ + "img/my_qrcode_facebook.8e5d826.webp";